<template>
  <v-flex xs12>
    <v-layout row wrap justify-center >          
      <v-flex xs12>
        <h1 class="payment__title text-xs-center">
          {{ service.name }}
        </h1>
      </v-flex>
      <RateItem v-for='rate in service.rates' :key='rate.id' :rate='rate' :slug='service.slug'/>
    </v-layout>
  </v-flex>
</template>

<script>
  import RateItem from './RateItem';

  export default {
    name: 'ServiceItem',
    components: {
      RateItem
    },
    props: {
      service: {
        type: Object,
        required: true
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/apps/account/components/Payment/ServiceItem.vue